import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TokenExpiredModal from "./components/TokenExpiredModal";
import AppLayout from "./AppLayout";

import PortalLogin_Controller from "./Controllers/Login_Controllers/PortalLogin_Controller";
import SetPassword_View from "./Views/SetPassword_View";
import ForgotPassword_View from "./Views/ForgotPassword_View";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <TokenExpiredModal />
      <Routes>
        {/* Route pubbliche */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<PortalLogin_Controller />} />
        <Route path="/imposta-password" element={<SetPassword_View />} />
        <Route path="/reset-password" element={<SetPassword_View />} />
        <Route path="/password-dimenticata" element={<ForgotPassword_View />} />

        {/* Route protette — tutte gestite da AppLayout */}
        <Route path="/*" element={<AppLayout />} />
      </Routes>
    </BrowserRouter>
  );
}
